/**
 * Подстановка плейсхолдеров в текстах опроса.
 * Поддерживает {{name}}, {{имя}}, {brand_name} и т.п.
 */
export function interpolatePollText(
  text: string | null | undefined,
  variables: Record<string, string | null | undefined> | undefined,
): string {
  if (!text) return ''
  if (!variables) return text

  const normalized: Record<string, string> = {}
  for (const [key, value] of Object.entries(variables)) {
    if (value == null) continue
    const raw = String(value)
    if (!raw.trim()) continue
    normalized[key] = raw
    normalized[key.toLowerCase()] = raw
  }

  let result = text.replace(
    /\{\{\s*([^{}]+?)\s*\}\}|\{([^{}]+?)\}/g,
    (match, doubleKey, singleKey) => {
      const key = String(doubleKey || singleKey || '').trim()
      if (!key) return match
      const value = normalized[key] ?? normalized[key.toLowerCase()]
      return value != null ? value : match
    },
  )

  // Legacy: в админке иногда писали голое «имя» без скобок («Спасибо, имя»).
  const bareName = normalized['имя'] || normalized['name'] || normalized['first_name']
  if (bareName) {
    result = result.replace(/(^|,\s*)имя(?=\s*[.!?]|$)/giu, `$1${bareName}`)
  }

  return result
}

/**
 * Переменные для плейсхолдеров имени в опросе.
 * Все ({{name}}, {{имя}}, {{фио}}, {{full_name}}, {{first_name}}, «Имя») получают строку
 * пользователя целиком, как она сохранена при регистрации — без обрезки и разбиения.
 */
export function buildPollNameVariables(
  userName: string | null | undefined,
): Record<string, string> {
  const full = userName == null ? '' : String(userName)
  if (!full.trim()) return {}
  return {
    name: full,
    имя: full,
    фио: full,
    user_name: full,
    full_name: full,
    first_name: full,
  }
}
